// Colorblind-safe categorical palette (project `dataviz` skill reference
// palette; validated for adjacent-pair CVD separation via its
// scripts/validate_palette.js -- worst adjacent pair CVD deltaE 9.1,
// normal-vision deltaE 19.6, both above the skill's floors).
//
// Shared between the 2D interaction graph (GraphExplorer.js, canvas-drawn)
// and the 3D NGL structure viewer (ProteinStructureViewer.js, via a custom
// NGL color scheme) so a given chain letter always renders as the same
// color in both linked views -- previously the 3D view used NGL's built-in
// "chainid" scheme, indexed off the whole downloaded PDB entry's chain
// list, which had nothing to do with this palette.
//
// Only the first 3 slots are validated for *all-pairs* separation; beyond
// that, some pairs fall into the CVD "warn" band (still legal per the
// skill's rule since this app always pairs color with a visible chain
// letter -- chips, legend, and tooltips never rely on color alone).
export const CHAIN_COLORS = [
  "#2a78d6", // blue
  "#eb6834", // orange
  "#1baf7a", // aqua
  "#eda100", // yellow
  "#e87ba4", // magenta
  "#008300", // green
  "#4a3aa7", // violet
  "#e34948"  // red
];

export const getChainColor = chain => {
  const value = String(chain || "?");
  const code = value.split("").reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return CHAIN_COLORS[code % CHAIN_COLORS.length];
};
